import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../context/useAppContext';
import { useHistory } from 'react-router-dom';
import { Card, Icon } from '@weezevent/nacre';

export default function DesignEmpty({ event = null }) {
    const [{ organization }] = useAppContext();
    const history = useHistory();
    const { t } = useTranslation();

    const handleClick = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/${event ? `E${event.id}/settings/` : ''}tickets_design/designs/new`);
    }, [history, organization, event]);

    return (
        <Card.EmptyState
            title={t('ticket.ticket_design.designs.empty.title')}
            subtitle={t('ticket.ticket_design.designs.empty.description')}
            icon={<Icon name="list" />}
            labelButton={t('ticket.ticket_design.create_design.title')}
            onClick={handleClick}
        />
    );
}
